/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Error_DeleteInputs */



/**
* | output |
* | --- |
* | "Delete failed" |
*
* @param {Tournament_Error_DeleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_error_delete = /** @type {((inputs?: Tournament_Error_DeleteInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Error_DeleteInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la suppression")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al eliminar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Exclusão falhou")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eliminazione fallita")
	return /** @type {LocalizedString} */ ("Delete failed")
});